import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import CartIcon from './CartIcon';
import { useCartPersistence } from '../hooks/useCartPersistence';
import toast from 'react-hot-toast';

const Header = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  
  // Initialize cart persistence
  useCartPersistence();

  const handleLogout = () => {
    logout();
    toast.success('Logged out successfully');
  };

  const handleLogoClick = () => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  };

  return (
    <header style={{ 
      background: 'white', 
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      marginBottom: '20px',
      position: 'sticky',
      top: 0,
      zIndex: 1000
    }}>
      <div className="container" style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        padding: '16px 20px' 
      }}>
        <div 
          onClick={handleLogoClick}
          style={{ 
            cursor: isAuthenticated ? 'pointer' : 'default',
            transition: 'transform 0.2s ease'
          }}
          onMouseEnter={(e) => {
            if (isAuthenticated) {
              e.target.style.transform = 'scale(1.02)';
            }
          }}
          onMouseLeave={(e) => {
            if (isAuthenticated) {
              e.target.style.transform = 'scale(1)';
            }
          }}
        >
          <h2 style={{ 
            margin: 0, 
            color: '#007bff',
            userSelect: 'none'
          }}>
            🚗 Automotive Parts Store
          </h2>
        </div>
        
        {isAuthenticated && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <CartIcon />
            <div>
              <span>Welcome, {user.firstName}</span>
              {user.roles?.includes('ADMIN') && (
                <span style={{ 
                  marginLeft: '8px',
                  background: '#dc3545',
                  color: 'white',
                  padding: '2px 8px',
                  borderRadius: '4px',
                  fontSize: '12px'
                }}>
                  ADMIN
                </span>
              )}
            </div>
            <button 
              onClick={handleLogout}
              className="btn btn-secondary"
              style={{ padding: '8px 16px' }}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header; 